import { Pipe, PipeTransform } from "@angular/core";
import { formatAge } from "src/app/support/format-age";
import { Nullable } from "src/app/support/nullable";

@Pipe({
  name: "age",
  standalone: false
})
export class AgePipe implements PipeTransform {
  transform(startDate: Nullable<string | number>, endDate?: string): string {
    return formatAge(startDate, endDate);
  }
}
